<div style="display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column;">
        <div id="dropzone-external" class="flex-box"
            [ngClass]="isDropZoneActive ? ['dx-theme-accent-as-border-color', 'dropzone-active'] : ['dx-theme-border-color']"
            title="Click to browse for an image file.">
            <img id="dropzone-image" [src]="imageSource" *ngIf="imageSource" alt="Client Photo" width="150" height="150"
                style="border-radius: 5px;" />
            <div id="dropzone-text" class="flex-box" *ngIf="imageSource==''">
                <span>Click here to browse for a client photo file on your computer.</span>
            </div>
        </div>
        <dx-file-uploader #fileUploader dialogTrigger="#dropzone-external" dropZone="#dropzone-external"
            [multiple]="false" [allowedFileExtensions]="['.jpg', '.jpeg', '.png']" accept="image/*" uploadMode="instantly"
            [visible]="false" (onDropZoneEnter)="onDropZoneEnter($event)" (onDropZoneLeave)="onDropZoneLeave($event)"
            (onValueChanged)="onValueChanged($event)">
        </dx-file-uploader>
    </div>
    <div style="display: flex; flex-direction: column;margin-left:20px">
        <span style="margin:5px">
            To set the client's photo, click the panel to the left to browse for a file. The file must be a PNG or JPG
            file and not be larger than 4Mb in size.
        </span>

        <dx-button style="margin:5px" stylingMode="contained" text="Clear" type="normal" [width]="120"
            (onClick)="btnDeleteImage($event)">
        </dx-button>

        <dx-button [visible]="isWebCamAvailable" style="margin:5px" stylingMode="contained" text="WebCam"
            type="normal" [width]="120" (onClick)="btnUseWebCam($event)">
        </dx-button>
    </div>
</div>
<app-client-photo (CloseDlg)="webCamImageCaptured($event)"></app-client-photo>